export default function FinancialQuotes() {
  const quotes = [
    {
      text: "Rule No. 1: Never lose money. Rule No. 2: Never forget Rule No. 1.",
      author: "Warren Buffett",
      role: "Investment Legend",
      image: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=200&h=200&fit=crop",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      text: "It's not how much money you make, but how much money you keep, how hard it works for you, and how many generations you keep it for.",
      author: "Robert Kiyosaki",
      role: "Author, Rich Dad Poor Dad",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      text: "I have no magic formula. The only thing I can say is that risk comes from not knowing what you're doing.",
      author: "Rakesh Jhunjhunwala",
      role: "Big Bull of India",
      image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=200&h=200&fit=crop",
      gradient: "from-orange-500 to-red-600"
    },
    {
      text: "If you don't find a way to make money while you sleep, you will work until you die.",
      author: "Radhakishan Damani",
      role: "Founder, DMart",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop",
      gradient: "from-purple-500 to-pink-600"
    },
    {
      text: "Take the stones people throw at you, and use them to build a monument.",
      author: "Ratan Tata",
      role: "Chairman Emeritus, Tata Sons",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop",
      gradient: "from-indigo-500 to-blue-600"
    },
    {
      text: "An investment in knowledge pays the best interest.",
      author: "Benjamin Franklin",
      role: "Founding Father",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop",
      gradient: "from-teal-500 to-cyan-600"
    },
    {
      text: "The stock market is a device for transferring money from the impatient to the patient.",
      author: "Vijay Kedia",
      role: "Indian Investor",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop",
      gradient: "from-red-500 to-orange-600"
    },
    {
      text: "Equity as an asset class will beat all other asset classes over a longer period of time.",
      author: "Raamdeo Agrawal",
      role: "Co-founder, Motilal Oswal",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop",
      gradient: "from-emerald-500 to-teal-600"
    },
    {
      text: "Quality companies with consistent earnings growth and strong management will always create wealth.",
      author: "Mukul Agrawal",
      role: "Ace Investor",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop",
      gradient: "from-violet-500 to-purple-600"
    },
    {
      text: "Invest in companies where promoters have skin in the game and demonstrated execution capabilities.",
      author: "Ashish Kacholia",
      role: "Big Whale Investor",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop",
      gradient: "from-amber-500 to-orange-600"
    },
    {
      text: "The best investment is in yourself. The more you learn, the more you earn.",
      author: "Madhusudan Kela",
      role: "Veteran Investor",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop",
      gradient: "from-rose-500 to-pink-600"
    },
    {
      text: "Price is what you pay. Value is what you get.",
      author: "Warren Buffett",
      role: "Oracle of Omaha",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop",
      gradient: "from-cyan-500 to-blue-600"
    }
  ];

  return (
    <section className="py-8 md:py-12 bg-gradient-to-br from-gray-50 via-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <span className="inline-block bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold mb-2">
            Words of Wisdom
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Learn from the <span className="text-blue-600">Financial Masters</span>
          </h2>
          <p className="text-sm text-gray-600 max-w-2xl mx-auto">
            Timeless wisdom from legendary investors
          </p>
        </div>

        {/* Quotes Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {quotes.map((quote, index) => (
            <div 
              key={index}
              className="group"
            >
              <div className="bg-white rounded-lg shadow hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-200 hover:border-blue-300 h-full flex flex-col">
                {/* Quote Content */}
                <div className="px-4 pt-3 pb-4 flex-grow flex flex-col">
                  {/* Large Quote Mark */}
                  <div className="text-3xl text-blue-200 font-serif leading-none mb-1">"</div>
                  
                  {/* Quote Text */}
                  <p className="text-gray-800 text-[15px] leading-relaxed mb-1 font-medium flex-grow line-clamp-3">
                    {quote.text}
                  </p>
                  
                  {/* Closing Quote Mark */}
                  <div className="text-3xl text-blue-200 font-serif leading-none text-right mb-3">"</div>

                  {/* Author Section */}
                  <div className="flex items-center gap-2 mt-auto">
                    {/* Author Photo */}
                    <div className={`relative flex-shrink-0 bg-gradient-to-br ${quote.gradient} p-0.5 rounded-full`}>
                      <div className="bg-white p-0.5 rounded-full">
                        <img 
                          src={quote.image}
                          alt={quote.author}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      </div>
                    </div>

                    {/* Author Details */}
                    <div className="min-w-0">
                      <p className="font-bold text-gray-900 text-xs truncate">{quote.author}</p>
                      <p className="text-[10px] text-gray-600 truncate">{quote.role}</p>
                    </div>
                  </div>
                </div>

                {/* Decorative Bottom Border */}
                <div className={`h-0.5 bg-gradient-to-r ${quote.gradient}`}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-8 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-lg p-5 shadow-lg">
            <h3 className="text-lg font-bold mb-2">Ready to Start Your Wealth-Building Journey?</h3>
            <p className="text-blue-100 mb-3 max-w-2xl mx-auto text-xs">
              Let these timeless principles guide your financial decisions. Get personalized advice from a certified advisor.
            </p>
            <a
              href="#contact"
              className="inline-block bg-white text-blue-600 px-5 py-2 rounded-lg hover:bg-gray-50 transition-all shadow-md font-semibold text-xs"
            >
              Start Your Financial Planning
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
